class Validation {
    constructor() {
        this.errors = {};
    }

    store(errors) {
        this.errors = errors
    }

    hasError(item) {
        if (this.errors[item]) {
            return this.errors.hasOwnProperty.call(item, 0);
        }
    }

    errorTitle(item) {
        if (this.errors[item]) {
            return this.errors[item][0];
        }
    }
}

export default Validation;